module.exports = __webpack_public_path__ + "img/estimates2.e60a6b01.svg";